module.exports = __webpack_public_path__ + "static/media/hambWhite.46fde31f.svg";